import { render, staticRenderFns } from "./TariffHistoryDialog.vue?vue&type=template&id=dd5097e2&scoped=true&lang=pug"
import script from "./TariffHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TariffHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5097e2",
  null
  
)

export default component.exports